module.exports = __webpack_public_path__ + "static/img/L48804656.09214df1.jpg";